import persistReducer from "redux-persist/lib/persistReducer";
import storage from "redux-persist/lib/storage";

import { jarvisPrimeInvestMoreConstants } from "./jarvisPrimeInvestMoreConstants";

const initialState = {
    investmentStocks: {},
    loading: {
        investmentStocks: 0,
    },
};

export const jarvisPrimeInvestMoreReducers = persistReducer(
    {
        storage,
        key: "investMore",
        blacklist: ["loading"],
    },
    (state = initialState, { type, payload }) => {
        switch (type) {
            case jarvisPrimeInvestMoreConstants.PRIME_INVESTMENT_STOCKS_REQUEST: {
                return {
                    ...state,
                    // investmentStocks: initialState.investmentStocks,
                    loading: {
                        ...state.loading,
                        investmentStocks: 1,
                    },
                };
            }

            case jarvisPrimeInvestMoreConstants.PRIME_INVESTMENT_STOCKS_RESPONSE: {
                return {
                    ...state,
                    investmentStocks: payload,
                    loading: {
                        ...state.loading,
                        investmentStocks: 0,
                    },
                };
            }

            case jarvisPrimeInvestMoreConstants.RESET_PRIME_INVEST_MORE_DATA:
                return initialState;

            default: {
                return state;
            }
        }
    }
);
